<template>
  <aside class="aside-menu">
    <aside-filter></aside-filter>
  </aside>
</template>

<script>
  import AsideFilter from './AsideFilter'
  export default {
      name: 'aside',
    components:{AsideFilter}
}
</script>



// WEBPACK FOOTER //
// src/components/Aside.vue